import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';
const AuthLoader = () => {
    return (
        <div 
        style={{
            "margin": "auto",
            "padding": "10px",
            "textAlign": "center",
            "padding": "20% 0"
        }}
        // className='authscss'
        >
            <p 
            style={{
                "line-height": "1.5",
                "display": "inline-block",
                "vertical-align": "middle",
                "fontWeight": "bold"
            }}
            >
                
                <CircularProgress color="secondary" />
            </p>
        </div>
    )
}


export default AuthLoader